import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import ViewAsBanner from "./ViewAsBanner";
import "./Layout.css";
import { useGetCurrentUserQuery } from "../../services/api";
import { updateCompany, selectCurrentCompany } from "../../store/slices/authSlice";

export default function DashboardLayout() {
  const dispatch = useDispatch();
  const currentCompany = useSelector(selectCurrentCompany);

  // Poll /auth/me every 60s to catch company status changes (e.g. admin deactivation)
  const { data: freshUser } = useGetCurrentUserQuery(undefined, {
    pollingInterval: 60_000,
  });

  useEffect(() => {
    if (freshUser?.company && currentCompany) {
      const freshActive = freshUser.company.isActive;
      if (freshActive !== currentCompany.isActive) {
        dispatch(updateCompany({ isActive: freshActive }));
      }
    }
  }, [freshUser, currentCompany, dispatch]);

  return (
    <div className="dashboard" data-layout="dashboard">
      {/* Persistent sidebar on every page */}
      <Sidebar />

      {/* Right side: navbar + page content */}
      <div className="content-area">
        <ViewAsBanner />
        <Navbar />
        <main className="main" data-layout="main">
          <div className="container-fluid" data-layout="container">
            {/* Child route content (Dashboard, Values, etc.) renders here */}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
